// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.875}
      d="M16.6663 10V10.8333C16.6663 14.5152 13.6816 17.5 9.99967 17.5C6.31778 17.5 3.33301 14.5152 3.33301 10.8333V10M9.99967 14.1667C8.15873 14.1667 6.66634 12.6743 6.66634 10.8333V5.83333C6.66634 3.99238 8.15873 2.5 9.99967 2.5C11.8406 2.5 13.333 3.99238 13.333 5.83333V10.8333C13.333 12.6743 11.8406 14.1667 9.99967 14.1667Z"
    />
  </svg>
);
const IconMicrophoneEnabled = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconMicrophoneEnabled;
